import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DividerModule } from 'primeng/divider';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { AddressCardModule } from '../address-card/address-card.module';
import { AddressEditModalModule } from '../address-edit-modal/address-edit-modal.module';
import { AddressInfoComponent } from './address-info.component';

@NgModule({
  declarations: [AddressInfoComponent],
  imports: [
    CommonModule,
    DividerModule,
    AddressCardModule,
    AddressEditModalModule,
    DynamicDialogModule
  ],
  exports: [AddressInfoComponent]
})
export class AddressInfoModule {}
